<template>
  <div class="drug-detail xi" v-if="drugDetail.category" :class="drugDetail.category == '中成药' ? 'zhong' : 'xi'">
    <div class="topfixed">
      <hd-com></hd-com>
      <div class="banner">
        <div class="banner-text">
          <h3>{{ drugDetail.drugName }}</h3>
          <p>
            当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><router-link to="/Drug/DrugBank">药品库 </router-link><i class="el-icon-arrow-right"></i><a>{{ drugDetail.drugName }}</a>
          </p>
          <div class="banner-right">
            <span @click="onCompatibility(drugDetail)">加入配伍</span>
            <span v-if="!exist" @click="onCollection(drugDetail)">加入收藏</span>
            <span v-else @click="deleteAll()">取消收藏</span>
            <span @click="goback()" v-if="canBack">返回</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrap">
      <div class="content clearfix">
        <el-scrollbar class="left-nav-wrap">
          <!-- 具体要包裹的内容 -->
          <div class="fast-nav">
            <ul class="timeline is-reverse">
              <li class="timeline-item" v-for="(item, index) in drugDetail.infos.filter((i) => i.title != '禁忌')" :key="index" v-show="item.info" @click="jump(index + 1)">
                <div class="timeline-item__tail" v-if="!drugDetail.drugCategories && index != drugDetail.infos.filter((i) => i.title != '禁忌').length - 1"></div>
                <div class="timeline-item__tail" v-if="drugDetail.drugCategories"></div>
                <div class="timeline-item__node"></div>
                <div class="timeline-item__text">
                  <h3 data-size="17">{{ item.title }}</h3>
                </div>
              </li>

              <li class="timeline-item" v-show="drugDetail.drugCategories" @click="jump(drugDetail.infos.length)">
                <div class="timeline-item__node"></div>
                <div class="timeline-item__text">
                  <h3 data-size="17">同类药</h3>
                </div>
              </li>
            </ul>
          </div>
        </el-scrollbar>
        <div class="detail-box">
          <div class="detail-tit sd-div">
            <h4 data-size="24">{{ drugDetail.drugName }}说明书</h4>
            <p data-size="14">请仔细阅读说明书并在医师指导下使用</p>
          </div>
          <div class="sd-div" v-for="(item, index) in drugDetail.infos.filter((i) => i.title != '禁忌')" :key="index" v-show="item.info">
            <h3 class="sd-tit" data-size="22">{{ item.title }}</h3>
            <div class="sd-mes">
              <p data-size="16" v-html="math(item.info.replace(/\n/g, '</p> <p>'))"></p>
            </div>
          </div>
          <div class="sd-div" v-show="drugDetail.drugCategories != 0">
            <h3 class="sd-tit" data-size="22">同类药</h3>
            <el-collapse v-for="(drugRelation, index) in drugRelations" :key="index">
              <el-collapse-item :title="drugRelation[0].relationType.replace('化学药品和生物制品', '西药')" name="index" v-if="drugRelation[0].relationType != '中成药'">
                <template>
                  <ul class="zhongyao clearfix" v-if="drugRelation[0].relationType == '中药饮片'">
                    <li class="zhongyao-item" v-for="(drugRelationitem, index) in drugRelation[0].items.slice(0, 8)" :key="index" @click="toMaterialDetail(drugRelationitem.hashKey)">
                      <div class="zhongyao-img">
                        <img v-if="drugRelationitem.itemPhoto" :src="drugRelationitem.itemPhoto" alt="" />
                        <img v-else src="../../assets/img/zyc_img.png" alt="" />
                      </div>
                      <p class="zhongyao-name">
                        {{ drugRelationitem.itemName }}
                      </p>
                    </li>
                    <a class="more-btn" v-if="drugRelation[0].items.length >= 8" @click="toMaterialMore(drugRelation[0].categoryId)">更多...</a>
                  </ul>
                  <ul class="hxsw" v-if="drugRelation[0].relationType == '中药方剂'">
                    <li v-for="(drugRelationitem, index) in drugRelation[0].items" :key="index">
                      <!-- <el-button type="success" plain
                                                @click="toHerbalDetail(drugRelationitem.hashKey)">
                                                {{
                                                    drugRelationitem.itemName
                                                }}
                                            </el-button> -->
                      <div :class="drugDetail.category == '中成药' ? 'hxswsucBtn' : 'xihxswsucBtn'" @click="toHerbalDetail(drugRelationitem.hashKey)">
                        {{ drugRelationitem.itemName }}
                      </div>
                    </li>
                    <a class="more-btn" v-if="drugRelation[0].HasMore" @click="toHerbalMore(drugRelation[0].categoryId)">更多...</a>
                  </ul>
                  <ul class="hxsw" v-if="drugRelation[0].relationType == '食疗药膳'">
                    <li v-for="(drugRelationitem, index) in drugRelation[0].items" :key="index">
                      <!-- <el-button type="success" plain
                                                @click="toFoodDetail(drugRelationitem.hashKey)">
                                                {{
                                                    drugRelationitem.itemName
                                                }}
                                            </el-button> -->
                      <div :class="drugDetail.category == '中成药' ? 'hxswsucBtn' : 'xihxswsucBtn'" @click="toFoodDetail(drugRelationitem.hashKey)">
                        {{ drugRelationitem.itemName }}
                      </div>
                    </li>
                    <a class="more-btn" v-if="drugRelation[0].HasMore" @click="toFoodMore(drugRelation[0].categoryId)">更多...</a>
                  </ul>
                  <ul class="hxsw" v-if="drugRelation[0].relationType == '中成药'">
                    <li v-for="(drugRelationitem, index) in drugRelation[0].items" :key="index">
                      <!-- <el-button type="success" plain @click="
                                                toDrugDetail(drugRelationitem.hashKey)
                                            ">{{ drugRelationitem.itemName }}</el-button> -->
                      <div :class="drugDetail.category == '中成药' ? 'hxswsucBtn' : 'xihxswsucBtn'" @click="toDrugDetail(drugRelationitem.hashKey)">
                        {{ drugRelationitem.itemName }}
                      </div>
                    </li>
                    <a class="more-btn" v-if="drugRelation[0].HasMore" @click="toDrugMore(drugRelation[0].categoryId, drugRelation[0].relationType)">更多...</a>
                  </ul>
                  <ul class="hxsw" v-if="drugRelation[0].relationType == '化学药品和生物制品'">
                    <li v-for="(drugRelationitem, index) in drugRelation[0].items" :key="index">
                      <!-- <el-button type="success" plain @click="
                                                toDrugDetail(drugRelationitem.hashKey)
                                            ">{{ drugRelationitem.itemName }}</el-button> -->
                      <div :class="drugDetail.category == '中成药' ? 'hxswsucBtn' : 'xihxswsucBtn'" @click="toDrugDetail(drugRelationitem.hashKey)">
                        {{ drugRelationitem.itemName }}
                      </div>
                    </li>
                    <a class="more-btn" v-if="drugRelation[0].HasMore" @click="toDrugMore(drugRelation[0].categoryId, drugRelation[0].relationType)">更多...</a>
                  </ul>
                </template>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="right-tips" v-for="(item, index) in drugDetail.infos.filter((i) => i.title == '禁忌')" :key="index" v-show="item.info">
          <div class="tips">
            <img src="../../assets/img/tips_icon.png" alt="" />
            <h4 data-size="20">禁忌</h4>
            <div class="tips-con">
              <p data-size="16" v-html="item.info"></p>
            </div>
            <div
              class="readAllBtn"
              v-if="item.info.toString().length >= 200"
              @click="
                detaildrawer = true;
                info = item.info;
              "
            >
              <span class="btn-text" data-size="16">查看全部 <i class="el-icon-arrow-down"></i></span>
            </div>
          </div>
        </div>
        <el-drawer title="禁忌" :visible.sync="detaildrawer" direction="rtl" wrapperClosable>
          <div class="drawer-box">
            <p data-size="16" v-html="info"></p>
          </div>
        </el-drawer>
      </div>
    </div>
    <ft-com></ft-com>
    <rt-bar></rt-bar>
    <staticTime></staticTime>
    <el-dialog
      title="释义"
      :visible.sync="dialogVisibleCi"
      width="30%"
      >
      <toDictionary :dictIds = "dictId"></toDictionary>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCi = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleCi = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import hdCom from "../../components/header"; //引入组件
import ftCom from "../../components/footer"; //引入组件
import rtBar from "../../components/right";
import staticTime from "../../components/staticTime";
import { toMaterial, toFood, toHerbal, toDrug, toDrugMore, toHerbalMore, toFoodMore, toMaterialMore } from "../../utils/relation";
import { DiseaseUtility, replaceContent, checkNameAndPath, toSearchList, toDetailInfo,toDetailInfoOpenTab } from "../../utils/diseaseUtility";
import { Drug } from "../../components/Drug/Drug";
import { DrugExtend } from "../../components/Drug/DrugExtend";
import { Collection } from "../../components/collection/Collection";
import { addCompare, getCompatibilityList } from "../../utils/Compatibility";
import toDictionary from "../../components/toDictionary"; //引入组件
export default {
  name: "DrugDetail",
  components: {
    hdCom,
    ftCom,
    rtBar,
    staticTime,
    toDictionary
  },
  data() {
    var drug = new Drug(this.TokenClient, this.Services.Drug);
    var drugExtend = new DrugExtend(this.TokenClient, this.Services.Drug);
    var collection = new Collection(this.TokenClient, this.Services.Statics);
    return {
      hashKey: this.$route.query.hashKey, //列表页id
      searchId: this.$route.query.searchId, //列表页searchId
      keyWord: this.$route.query.keyWord, //列表页KeyWord
      searchType: this.$route.query.searType, //
      drugDetail: {}, //初始化详情
      drugRelations: [], //初始化同类药
      drugDomain: drug,
      drugExtendDomain: drugExtend,
      scroll: "",
      collectionDomain: collection,
      entityData: {},
      fontSize: "",
      exist: false,
      collectionId: "",
      detaildrawer: false,
      info: {},
      canBack:true,
      dialogVisibleCi:false,
      dictId:0
    };
  },
  created() {
    this.canBack = window.history.length > 1;
    window.getPageInfo = this.getPageInfo;
  },
  methods: {
    
    math(info) {
      return replaceContent(info);
    },
    //跳转疾病详情
    getPageInfo(name, type, hashKey) {
      if (hashKey == "Search") {
        toSearchList(checkNameAndPath(type).typeName, name);
      } else {
        if (type == "Dict") {
          this.dialogVisibleCi = true
          this.dictId = hashKey
          console.log(this.dictId)
          //  this.showTooltip(name, type, hashKey,event);
        }
        else {
          toDetailInfoOpenTab(checkNameAndPath(type).path, hashKey, type);
        }
      }
    },
    readAll(e) {
      const target = e.currentTarget;
      // 寻找父元素的兄弟元素进行显示与隐藏控制
      $(target).prev().addClass("all");
      $(target).hide();
    },
    handleScroll() {
      let scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      let scrollObj = document.querySelector(".left-nav-wrap");
      let right = document.querySelector(".right-tips");
      let topfixed = document.querySelector(".topfixed");
      //scrollObj 这个是下图右边答题卡的div

      if (scrollY > 80) {
        topfixed.style.position = "fixed";
        topfixed.style.top = 0;
        topfixed.style.zIndex = 99;
        scrollObj.style.position = "fixed";
        scrollObj.style.top = "200px";
        right.style.position = "fixed";
        right.style.top = "230px";
      } else {
        topfixed.style.position = "initial";
        topfixed.style.top = "none";
        scrollObj.style.position = "absolute";
        scrollObj.style.top = "auto";
        right.style.position = "absolute";
        right.style.top = "auto";
      }
    },
    checkExist() {
      var _this = this;
      _this.collectionDomain.Exist(
        this.entityData.type,
        this.entityData.hashKey,
        this.entityData.id,
        function (data) {
          _this.exist = data.data.exist;
          _this.collectionId = data.data.collectionId;
        },
        function (err) {},
      );
    },
    //详情获取
    getDrugDetail: function () {
      var _this = this;
      _this.drugDetail = {}
      let params = `${_this.hashKey}`;
      _this.drugDomain.Detail(
        params,
        function (data) {
          _this.drugDetail = data.data;
          if (data.data.drugCategories.length > 0) {
            //获取同类药
            var cateName = "";
            data.data.drugCategories.forEach((item) => {
              cateName = cateName + item.categoryName + ",";
            });
            _this.getRelation(cateName.substring(0, cateName.length - 1), data.data.category);
            _this.DrugItemInfosData(data.data.category)
          }
          _this.entityData = {
            type: "drug",
            name: _this.drugDetail.drugName,
            hashKey: _this.drugDetail.hashKey,
            id: _this.drugDetail.drugId,
            entityType: _this.drugDetail.category,
          };
          _this.checkExist();
          _this.$bus.$emit("fontSize");
        },
        function (error) {
          console.log("药品详情请求异常。", error);
        },
      );
    },
    //获取同类药
    getRelation: function (CategoryName, typeName) {
      var _this = this;
      let params = `${CategoryName}/${typeName}`;
      _this.drugExtendDomain.Relations(
        params,
        function (data) {
          _this.drugRelations = data.data;
        },
        function (error) {
          console.log("同类药请求异常", error);
        },
      );
    },
    DrugItemInfosData(params){
      var _this = this;
      _this.drugDomain.DrugItemInfos(
        params,
        function (data) {
          console.log(data)
          // _this.drugRelations = data.data;
          let sortList = data.data
          const titleOrderMap = {}
          // 生成允许展示的标题集合
          const allowTitleSet = new Set()
          sortList.forEach(item => {
              titleOrderMap[item.title] = item.order
              allowTitleSet.add(item.title)
          })
          _this.drugDetail.infos = _this.drugDetail.infos.filter(item => allowTitleSet.has(item.title))
          //第二步：按order升序排序
          _this.drugDetail.infos = _this.drugDetail.infos.sort((a,b)=>{
              return titleOrderMap[a.title] - titleOrderMap[b.title]
          })
        },
        function (error) {
          console.log("同类药请求异常", error);
        },
      );
    },
    onCompatibility: function (item) {
      var compatibility = getCompatibilityList();
      console.log(compatibility);
      if (compatibility.length > 0) {
        if (compatibility.some((i) => i.hashKey == item.hashKey && i.type == "1")) {
          this.$message.error("已加入用药审查！");
          return false;
        }
      }
      addCompare(item.hashKey, item.drugName, 1, "drug");
      this.$message.success("成功加入用药审查！");
      this.$bus.$emit("right", "reload");
    },
    deleteAll: function () {
      var _this = this;
      var idarr = [_this.collectionId];
      _this.collectionDomain.Delete(
        idarr,
        function (data) {
          _this.checkExist();
          _this.$message({
            center: true,
            type: "success",
            message: "取消成功!",
          });
        },
        function (error) {
          console.log(error);
        },
      );
    },
    //收藏
    onCollection: function (item) {
      var _this = this;
      var entityType = 0;
      if (item.category.indexOf("化学药品和生物制品") != -1) {
        entityType = 3;
      }
      if (item.category.indexOf("中成药") != -1) {
        entityType = 4;
      }
      _this.collectionDomain.Put(
        "drug",
        item.drugName,
        item.hashKey,
        item.drugId,
        entityType,
        function (data) {
          _this.checkExist();
          _this.$message({
            type: "success",
            message: "收藏成功!",
          });
        },
        function (err) {
          if (err.status === 400) {
            _this.$message.error("请勿重复收藏!");
          }
        },
      );
    },
    //跳转同类药-中药更多
    toMaterialMore(cateid) {
      toMaterialMore(cateid);
    },
    //跳转同类药-中药详情
    toMaterialDetail(id) {
      toMaterial(id, this.searchId, this.keyword);
    },
    //跳转同类药-食疗药膳更多
    toFoodMore(cateid) {
      toFoodMore(cateid);
    },
    //跳转同类药-食疗药膳详情
    toFoodDetail(id) {
      toFood(id, this.searchId, this.keyword);
    },
    //跳转同类药-中药方剂更多
    toHerbalMore(cateid) {
      toHerbalMore(cateid);
    },
    //跳转同类药-中药方剂详情
    toHerbalDetail(id) {
      toHerbal(id, this.searchId, this.keyword);
    },
    //跳转同类药-中西药更多
    toDrugMore(cateid, type) {
      toDrugMore(cateid, type);
    },
    //跳转同类药-中西药详情
    toDrugDetail(hashKey) {
      this.hashKey = hashKey;
      this.getDrugDetail();
    },
    replace: function (content) {
      return content.replace(/\n/g, "</p> <p>");
    },
    dataScroll: function () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    jump(index) {
      let jump = document.getElementsByClassName("sd-div");
      // 获取需要滚动的距离
      // console.log(jump[index])
      let total = jump[index].offsetTop - 200;
      window.scroll(0, total);
      // Chrome
      //document.body.scrollTop = total;
      // Firefox
      //document.documentElement.scrollTop = total;
      // Safari
      //window.pageYOffset = total;
      // $('html, body').animate({
      // 'scrollTop': total
      // }, 400);
    },
    loadSroll: function () {
      var self = this;
      var $navs = $(".timeline .timeline-item");
      var sections = document.getElementsByClassName("sd-div");
      for (var i = sections.length - 1; i >= 0; i--) {
        if (self.scroll >= sections[i].offsetTop - 200) {
          $navs
            .eq(i - 1)
            .addClass("active")
            .siblings()
            .removeClass("active");
          break;
        }
      }
    },
    goback() {
      this.$router.go(-1);
    },
  },
  watch: {
    scroll: function () {
      this.loadSroll();
    },
  },
  mounted() {
    this.$bus.$emit("select", "drug");
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.dataScroll);
    this.getDrugDetail();
  },
  destroyed() {
    //销毁监听
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.dataScroll);
  },
};
</script>

<style scoped>
@import "../../assets/css/header.css";
@import "../../assets/css/footer.css";
.hxswsucBtn {
  display: inline-block;
  padding: 5px 15px;
  margin: 7px 12px 5px 0;
  border-radius: 2px;
  font-size: 14px;
  color: #b76c12;
  background-color: #ffffff;
  border: 1px solid #b76c12;
  cursor: pointer;
}
.hxswsucBtn:hover {
  display: inline-block;
  padding: 5px 15px;
  margin: 7px 12px 5px 0;
  border-radius: 2px;
  font-size: 14px;
  color: #f3f0eb;
  background-color: #b76c12;
  border: 1px solid #b76c12;
  cursor: pointer;
}
.xihxswsucBtn {
  display: inline-block;
  padding: 5px 15px;
  margin: 7px 12px 5px 0;
  border-radius: 2px;
  font-size: 14px;
  color: #1fb7a6;
  background-color: #ffffff;
  border: 1px solid #1fb7a6;
  cursor: pointer;
}
.xihxswsucBtn:hover {
  display: inline-block;
  padding: 5px 15px;
  margin: 7px 12px 5px 0;
  border-radius: 2px;
  font-size: 14px;
  color: #f3f0eb;
  background-color: #1fb7a6;
  border: 1px solid #1fb7a6;
  cursor: pointer;
}
.banner {
  width: 100%;
  height: 116px;
  background: url("../../assets/img/ypk_banner.jpg") center no-repeat;
}

.zhong .banner {
  background: #b76c12;
}

.banner-text {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}

.banner-text h3 {
  padding-top: 25px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text h3 span {
  font-size: 14px;
}

.banner-text p {
  margin-top: 7px;
  font-size: 14px;
  color: #ffffff;
}

.banner-text p a {
  color: #ffffff;
  font-size: 14px;
  margin: 0 5px;
}

.banner-right {
  position: absolute;
  right: 5px;
  top: 45px;
}

.banner-right span {
  display: inline-block;
  margin-left: 20px;
  width: 132px;
  height: 32px;
  border: 1px solid #ffffff;
  border-radius: 32px;
  box-sizing: border-box;
  text-align: center;
  color: #ffffff;
  line-height: 30px;
  cursor: pointer;
}

.banner-right span:hover {
  background-color: #ffffff;
  color: #00ab98;
}

.zhong .banner-right span:hover {
  background-color: #ffffff;
  color: #b76c12;
}

/*内容部分*/
.content-wrap {
  background: #f8f8f8;
}

.content-wrap .content {
  position: relative;
  width: 1420px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 60px;
  background-color: rgba(255, 255, 255, 0);
}

.detail-box {
  float: left;
  margin-left: 260px;
  padding: 30px 35px;
  width: 830px;
  background: #ffffff;
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
}

.detail-tit h4 {
  font-size: 24px;
  color: #333333;
  text-align: center;
}

.detail-tit p {
  font-size: 14px;
  line-height: 28px;
  color: #999999;
  text-align: center;
}

.detail-top {
  padding: 15px 25px;
  background: #f8f8f8;
}

.detail-top .dyimg {
  text-align: center;
}

.detail-top .dyimg p {
  font-size: 12px;
  color: #333333;
}

.detail-top .dyname {
  margin-left: 20px;
  padding: 0 10px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  background: #f0f0f0;
  font-size: 14px;
  color: #333333;
}

.detail-top .dyname p i {
  margin-right: 10px;
  display: inline-block;
  color: #e62828;
  font-size: 12px;
  background-color: #ffffff;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  text-align: center;
  font-style: normal;
}

.sd-div {
  padding: 30px 0;
  border-top: 1px solid #e5e5e5;
}

.sd-div:first-child {
  border-top: 0px;
}

.sd-div .sd-tit {
  font-size: 22px;
  color: #333333;
  font-weight: normal;
  margin-bottom: 30px;
}

.sd-div .sd-tit.overview {
  font-size: 26px;
  color: #333333;
  padding-left: 15px;
  border-left: 3px solid #333;
  line-height: 26px;
}

.hxsw li {
  margin: 2px 0;
  display: inline-block;
  height: 42px;
  /* border: 1px solid #999999; */
  padding: 0 5px;
  box-sizing: border-box;
}

.hxsw li a {
  line-height: 42px;
  text-align: center;
  color: #666666;
  font-size: 16px;
  cursor: pointer;
}

.hxsw li:hover {
  border-color: #00ab98;
}

.hxsw li:hover a {
  color: #00ab98;
}

.zhong .hxsw li:hover {
  border-color: #b76c12;
}

.zhong .hxsw li:hover a {
  color: #b76c12;
}

.zhongyao {
  text-align: center;
}

.zhongyao li {
  float: left;
  width: 184px;
  height: 184px;
  margin: 10px;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
}

.zhongyao li .zhongyao-img {
  width: 120px;
  height: 120px;
  margin: 15px auto 5px;
}

.zhongyao li .zhongyao-img img {
  width: 100%;
  height: auto;
}

.zhongyao li .zhongyao-name {
  font-size: 18px;
  text-align: center;
  color: #333333;
}

.zhongyao li:hover {
  border-color: #b76c12;
  cursor: pointer;
}

.zhongyao li:hover .zhongyao-name {
  color: #b76c12;
}

.zhongyao .more-btn {
  display: inline-block;
}

/* .more-btn {
    margin: 10px auto;
    display: block;
    width: 124px;
    height: 38px;
    line-height: 38px;
    background-color: #1fb7a6;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
} */

.zhong .more-btn {
  margin: 10px auto;
  display: inline-block;
  width: 124px;
  height: 38px;
  line-height: 38px;
  background-color: #b76c12;
  color: #ffffff !important;
  text-align: center;
  cursor: pointer;
}

.left-nav-wrap {
  position: absolute;
  width: 250px;
  /* border: 1px solid #e5e5e5; */
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
  background: #ffffff;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  max-height: 470px;
  overflow-x: hidden;
}

.fast-nav {
  box-sizing: border-box;
  padding: 20px 0 20px 40px;
  z-index: 10;
}

.timeline-item {
  position: relative;
  padding-bottom: 17px;
  padding-top: 8px;
  cursor: pointer;
}

.timeline-item__tail {
  position: absolute;
  top: 15px;
  left: 3px;
  height: 100%;
  border-left: 1px solid #e5e5e5;
}

.timeline-item__node {
  position: absolute;
  background-color: #cccccc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 15px;
  left: -1px;
  width: 9px;
  height: 9px;
}

.timeline-item__text {
  position: relative;
  padding-left: 28px;
  top: -3px;
}

.timeline-item__text h3 {
  font-size: 17px;
  color: #333;
  font-weight: normal;
}

.timeline-item.active .timeline-item__node,
.timeline-item:hover .timeline-item__node {
  background-color: #1fb7a6;
}

.timeline-item.active .timeline-item__text h3,
.timeline-item:hover .timeline-item__text h3 {
  color: #1fb7a6;
}

.zhong .timeline-item.active .timeline-item__node,
.zhong .timeline-item:hover .timeline-item__node {
  background-color: #b76c12;
}

.zhong .timeline-item.active .timeline-item__text h3,
.zhong .timeline-item:hover .timeline-item__text h3 {
  color: #b76c12;
}

.right-tips {
  position: absolute;
  top: auto;
  margin-left: 1170px;
}

.tips {
  position: relative;
  margin-bottom: 30px;
  width: 250px;
  /* border: 1px solid #e5e5e5; */
  box-shadow: 5px 0 8px rgba(224, 224, 224, 0.3);
  padding: 20px;
  box-sizing: border-box;
  background-color: #fffdf9;
}

.tips img {
  position: absolute;
  top: -20px;
  left: calc(50% - 9px);
}

.tips h4 {
  color: #ff0101;
  font-size: 20px;
  margin-bottom: 15px;
  text-align: center;
}

.tips .tips-con /deep/ * {
  color: #ff0101 !important;
  font-size: 16px;
  line-height: 30px;
}

.tips .tips-con {
  max-height: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tips .tips-con.all {
  max-height: initial;
}

.readAllBtn {
  position: relative;
  height: 78px;
  margin-top: -68px;
  background-image: linear-gradient(rgba(255, 255, 255, 0.5), #ffffff);
  text-align: center;
}

.xi .readAllBtn .btn-text {
  width: 100%;
  position: absolute;
  bottom: 0;
  color: #1fb7a6;
  cursor: pointer;
  text-align: center;
  left: 0;
}

.zhong .readAllBtn .btn-text {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  color: #b76c12;
  cursor: pointer;
  text-align: center;
}

/*    */
.drawer-content {
  padding: 20px;
}

.drawer-box {
  padding: 30px;
}

.drawer-box /deep/ table {
  width: auto !important;
}
</style>
<style>
.drug-detail .el-collapse-item__header {
  background-color: #1fb7a6;
  color: #ffffff;
  font-size: 18px;
  padding: 0 20px;
}

.drug-detail.zhong .el-collapse-item__header {
  background-color: #b76c12;
  color: #ffffff;
  font-size: 18px;
  padding: 0 20px;
}

.drug-detail .el-collapse-item__header:hover {
  color: #ffffff;
}

.drug-detail .el-collapse-item__wrap {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.drug-detail .el-collapse-item__content {
  padding: 15px 5px;
}
</style>
